<ng-template #hostContent>
    <app-toolbar></app-toolbar>
    <div style="height: calc(100vh - 68px); width: 100%; overflow-y: auto; display: flex">
        <app-sidenav></app-sidenav>
        <main style="flex-grow: 1; overflow-y: auto">
            <router-outlet></router-outlet>
        </main>
    </div>
    <app-loading-spinner></app-loading-spinner>
</ng-template>

@if (chatbotService.view() === "sidebar" && !isChatbotRoute()) {
    <!--
        The Sidebar view docks the whole chatbot against the rest of the page, using a real
        `kendo-splitter` between the host's own content and the widget rather than an overlay drawn
        on top of it. The session-history drawer inside the widget stays a plain overlay regardless.
        See `SidebarComponent`. This splitter spans the full viewport height, including the top
        navbar, which lives inside the left pane instead of sitting outside the splitter.

        This branch stays mounted for the whole time the view is Sidebar, regardless of `isOpen()`.
        Only the widget's own pane collapses on close, through Kendo's collapsible-pane feature.
        Gating the splitter itself on `isOpen()` would tear this whole branch down and rebuild it on
        every close/reopen, including `hostContent`'s `<router-outlet>`, which would remount whatever
        page is routed and re-trigger its own HTTP calls (and, with them, the host's own loading
        spinner, since that guard only excludes the chatbot's own calls). Keeping the branch stable
        and only collapsing the widget's pane avoids remounting the host page at all. A collapsed
        pane's `@if (!collapsed) { <ng-content> }` still destroys `<avioblue-chatbot>`, which is
        fine: the conversation and the composer's unsent draft already survive that through
        `ChatWidgetStateService`/`MainComponent.draftMessage` in the library, independent of whether
        the component is alive.
    -->
    <kendo-splitter class="host-chat-splitter" style="height: 100vh; width: 100%">
        <kendo-splitter-pane>
            <ng-container [ngTemplateOutlet]="hostContent"></ng-container>
        </kendo-splitter-pane>
        <kendo-splitter-pane [collapsible]="true" [collapsed]="!chatbotService.isOpen()" size="400px" min="320px" max="60%">
            <avioblue-chatbot
                domain="camo"
                [initialView]="chatbotService.view()"
                [showAgentPicker]="false"
                [showViewPicker]="true"
                (closeRequested)="chatbotService.close()"
                (viewChanged)="onChatViewChanged($event)"
            >
            </avioblue-chatbot>
        </kendo-splitter-pane>
    </kendo-splitter>
} @else {
    <ng-container [ngTemplateOutlet]="hostContent"></ng-container>
    @if (chatbotService.isOpen() && !isChatbotRoute()) {
        <avioblue-chatbot
            domain="camo"
            [initialView]="chatbotService.view()"
            [showAgentPicker]="false"
            [showViewPicker]="true"
            (closeRequested)="chatbotService.close()"
            (viewChanged)="onChatViewChanged($event)"
        >
        </avioblue-chatbot>
    }
}
